












import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import AccountHolderHoldsAlert from "@/employer/components/partner-ee-service/AccountHolderHoldsAlert.vue";
import { useCustomerServiceUserStore } from "@/employer/store/customerServiceUser";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    AccountHolderHoldsAlert
  }
})
export default class AccountHolderDisplayName extends Vue {

  customerServiceUserStore = useCustomerServiceUserStore();
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  username: string;

  @Prop()
  partnerId: number;

  mounted () {
    this.load();
  }

  @Watch("username")
  @Watch("partnerId")
  load () {
    this.customerServiceUserStore.loadUser({username: this.username, partnerId: this.partnerId});
  }

  get isLoaded () {
    return !!this.customerServiceUserStore.userInfo(this.username);
  }

  get nameOfUser () {
    const userInfo = this.customerServiceUserStore.userInfo(this.username);
    return userInfo && `${userInfo.firstName} ${userInfo.lastName}`;
  }

  get employerName () {
    const userInfo = this.customerServiceUserStore.userInfo(this.username);
    return userInfo && userInfo.employerName;
  }

  get showEmployerName () {
    return this.employerName && this.employerName.length;
  }

  get bankAccountHoldsVisible (): boolean {
    return this.custodianSettingsStore.displayBankAccountHolds;
  }
}
